// extracted by mini-css-extract-plugin
export default {"lgrid":"Landing_lgrid__gZ+ri","gridCard":"Landing_gridCard__4R-uK","Img":"Landing_Img__z7a4R"};